$(function () {
    /* Dark Mode */
    const colorSchemes = ['light', 'dark', 'warm']
    let currentColorScheme = localStorage.getItem('colorScheme')
    if (!currentColorScheme) {
        currentColorScheme = colorSchemes[0]
        localStorage.setItem('colorScheme', currentColorScheme)
    }
    $(`.color-scheme-icon--${currentColorScheme}`).addClass('is-active')
    $('.color-scheme-toggle').on('click', function () {
        $('html').removeClass(`color-scheme--${currentColorScheme}`)
        $('.color-scheme-toggle span').removeClass('is-active')

        let pointer = colorSchemes.indexOf(currentColorScheme)
        currentColorScheme =
            pointer === colorSchemes.length - 1
                ? colorSchemes[0]
                : colorSchemes[pointer + 1]
        localStorage.setItem('colorScheme', currentColorScheme)

        $('html').addClass(`color-scheme--${currentColorScheme}`)
        $(`.color-scheme-icon--${currentColorScheme}`).addClass('is-active')
    })

    /* Hamburger Menu */
    $('.hamburger').on('click', function () {
        $(this).toggleClass('is-active')
        $('.hamburger-menu').toggleClass('is-active')
    })

    resizeFullWidthImages()
    $(window).on('resize', resizeFullWidthImages)

    /* Lightense image zoom */
    let siteMain = $('.site-main')
    if (typeof Lightense !== 'undefined') {
        Lightense('.kg-image-card img,.kg-gallery-card img', {
            beforeShow(config) {
                siteMain.css('overflow-x', 'initial')
            },
            afterHide(config) {
                siteMain.css('overflow-x', 'hidden')
            },
        })
    }

    /* Search */
    $('.search-toggle').on('click', function () {
        $('.search-view').show()
        $('body').css('overflow', 'hidden')

        if ($('.ghost-hunter-search').length > 0) {
            $('#ghost-hunter-search-input').focus()
        }
    })
    $('.search-close').on('click', function () {
        $('.search-view').hide()
        $('body').css('overflow', 'initial')
    })

    /* Discord Icon: Click to copy */
    $('.discord-icon, .social-media-links-vertical__discord').on(
        'click',
        function (e) {
            e.preventDefault()
            navigator.clipboard.writeText('zachschrier#0001')
            $(this).addClass('is-focused')
            setTimeout(function () {
                $(
                    '.discord-icon, .social-media-links-vertical__discord',
                ).removeClass('is-focused')
            }, 2000)
        },
    )
})

/* Resize full width images */
function resizeFullWidthImages() {
    let fullWidthImages = $('.kg-image-card.kg-width-full')
    if (fullWidthImages.length > 0) {
        let mainAreaWidth = $('.site-main').width()
        let postContentWidth = $('.post-content .container--boxed').width()
        let marginToOffset = (mainAreaWidth / 2 - postContentWidth / 2) * -1
        fullWidthImages.css({
            marginLeft: `${marginToOffset}px`,
            marginRight: `${marginToOffset}px`,
        })
    }
}
